import TicketDetailsStatusAlert from './TicketDetailsStatusAlert';

export default TicketDetailsStatusAlert;
